export const messages = {
  en: {
    attrSpec: {
      search: {
        title: 'Search Condition',
        domain: 'domain',
        specCd: 'specCd',
        tableName: 'tableName',
        specName: 'specName',
        specHoldplace: 'specHoldplace',
        required: 'required',
        specShow: 'specShow',
        specValueType: 'specValueType',
        specType: 'specType',
        listShow: 'listShow',
        createTime: 'createTime',
        placeholder: 'Please enter attrSpec name'
      },
      list: {
        title: 'attrSpec List'
      },
      dialog: {
        addTitle: 'Add AttrSpec',
        editTitle: 'Edit AttrSpec',
        delTitle: 'Delete AttrSpec',
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      form: {
        specId: 'specId',
        domain: 'domain',
        specCd: 'specCd',
        tableName: 'tableName',
        specName: 'specName',
        specHoldplace: 'specHoldplace',
        required: 'required',
        specShow: 'specShow',
        specValueType: 'specValueType',
        specType: 'specType',
        listShow: 'listShow',
        createTime: 'createTime',
      },
      table: {
        specId: 'specId',
        domain: 'domain',
        specCd: 'specCd',
        tableName: 'tableName',
        specName: 'specName',
        specHoldplace: 'specHoldplace',
        required: 'required',
        specShow: 'specShow',
        specValueType: 'specValueType',
        specType: 'specType',
        listShow: 'listShow',
        createTime: 'createTime',
      },
      validate: {
        specId: 'Please enter specId',
        domain: 'Please enter domain',
        specCd: 'Please enter specCd',
        tableName: 'Please enter tableName',
        specName: 'Please enter specName',
        specHoldplace: 'Please enter specHoldplace',
        required: 'Please enter required',
        specShow: 'Please enter specShow',
        specValueType: 'Please enter specValueType',
        specType: 'Please enter specType',
        listShow: 'Please enter listShow',
        createTime: 'Please enter createTime',
      },
      add: {
        success: 'Add AttrSpec success'
      },
      edit: {
        success: 'Edit AttrSpec success'
      },
      delete: {
        success: 'Delete AttrSpec success',
        confirm: 'Are you sure to delete this attrSpec?'
      },
      fetchError: 'Failed to fetch attrSpec list',
      value: 'value',

    }
  },
  zh: {
    attrSpec: {
      search: {
        title: '查询条件',
        domain: '域',
        specCd: '规格编码',
        tableName: '属性表',
        specName: '规格名称',
        specHoldplace: '说明',
        required: '是否必填',
        specShow: '展示',
        specValueType: '值类型',
        specType: '规格类型',
        listShow: '查询显示',
        createTime: '创建时间',
        placeholder: '请输入属性名称'
      },
      list: {
        title: '属性列表'
      },
      dialog: {
        addTitle: '添加属性',
        editTitle: '编辑属性',
        delTitle: '删除属性',
        cancel: '取消',
        confirm: '确定'
      },
      form: {
        specId: '主键ID',
        domain: '域',
        specCd: '规格编码',
        tableName: '属性表',
        specName: '规格名称',
        specHoldplace: '说明',
        required: '是否必填',
        specShow: '展示',
        specValueType: '值类型',
        specType: '规格类型',
        listShow: '查询显示',
        createTime: '创建时间',
      },
      table: {
        specId: '主键ID',
        domain: '域',
        specCd: '规格编码',
        tableName: '表名',
        specName: '规格名称',
        specHoldplace: '说明',
        required: '是否必填',
        specShow: '展示',
        specValueType: '值类型',
        specType: '规格类型',
        listShow: '查询显示',
        createTime: '创建时间',
      },
      validate: {
        specId: '请输入主键ID',
        domain: '请输入域',
        specCd: '请输入规格编码',
        tableName: '请输入表名',
        specName: '请输入规格名称',
        specHoldplace: '请输入说明',
        required: '请输入是否必填',
        specShow: '请输入展示',
        specValueType: '请输入值类型',
        specType: '请输入规格类型',
        listShow: '请输入查询显示',
        createTime: '请输入创建时间',
      },
      add: {
        success: '添加属性成功'
      },
      edit: {
        success: '编辑属性成功'
      },
      delete: {
        success: '删除属性成功',
        confirm: '确认删除该属性吗？'
      },
      fetchError: '获取属性列表失败',
      value: '离散值',
    }
  }
}